import { toast } from "react-toastify";

export const readImageFileAsDataUrl = (
    file: File | undefined,
    onReady: (dataUrl: string) => void
) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
        toast.error("Please select an image file.");
        return;
    }
    const reader = new FileReader();
    reader.onload = () => {
        if (typeof reader.result === "string") onReady(reader.result);
    };
    reader.onerror = () => toast.error("Unable to read the selected image.");
    reader.readAsDataURL(file);
};
